module.exports = __webpack_public_path__ + "img/104.bd2794e7.svg";